//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import WInput from './w-input'
import { XButton } from 'vux'

export default {
  name: 'register',
  data () {
    return {
      username: '',
      password: '',
      rePassword: '',

      error: false
    }
  },
  computed: {
    disabled () {
      if (this.rePassword !== this.password) {
        this.rePassword = ''
        //
        this.error = true
      } else {
        this.error = false
      }

      return (
        this.username.length === 0 ||
        this.password.length === 0 ||
        this.rePassword.length === 0
      )
    }
  },
  methods: {
    async register () {
      this.$vux.loading.show('注册用户中...')
      const res = await this.$register({
        username: this.username,
        password: this.password
      })
      // 连接socket
      await this.$connect()
      this.$vux.loading.hide()
      if (res.code === 0) {
        this.$router.replace({ name: 'message', query: { mode: 'modal' } })
      } else {
        this.$vux.toast.text(res.message, 'bottom')
      }
    }
  },
  components: {
    WInput,
    XButton
  }
}
